import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-grow pt-5 grid grid-cols-3 gap-3" }
const _hoisted_2 = { class: "flex flex-col mb-3 col-span-3" }
const _hoisted_3 = { class: "flex flex-col mb-3 col-span-3" }
const _hoisted_4 = { class: "col-span-3 grid grid-cols-4 gap-3" }
const _hoisted_5 = { class: "flex flex-col mb-3" }
const _hoisted_6 = { class: "flex flex-col mb-3" }
const _hoisted_7 = { class: "flex flex-col mb-3" }
const _hoisted_8 = { class: "flex flex-col mb-3" }
const _hoisted_9 = { class: "flex flex-col mb-3 col-span-2" }
const _hoisted_10 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_RigaIvaPianoFatturazione = _resolveComponent("RigaIvaPianoFatturazione")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
    backdrop: true
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("h2", { class: "text-lg font-bold" }, "Modifiva riga di pianificazione sulla versione " + _toDisplayString(_ctx.row_model.versione), 513), [
          [_vShow, _ctx.row_model?.id]
        ]),
        _withDirectives(_createElementVNode("h2", { class: "text-lg font-bold" }, "Aggiungi riga di pianificazione sulla versione " + _toDisplayString(_ctx.$attrs.versione.version), 513), [
          [_vShow, !_ctx.row_model?.id]
        ])
      ])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Field, {
            field_name: "Cliente",
            required: !_ctx.clienteAutocomplete?.selection,
            errors: _ctx.getErrors('cliente_id'),
            placeholder: "Cliente"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                onSearchChange: _ctx.clienteAutocomplete.search,
                loading: _ctx.clienteAutocomplete.isLoading,
                options: _ctx.clienteAutocomplete.options,
                modelValue: _ctx.clienteAutocomplete.selection,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.clienteAutocomplete.selection) = $event)),
                "track-by": "id",
                label: "denominazione",
                class: "next-vue-multiselect-single",
                placeholder: "Cliente",
                deselectLabel: "Deseleziona",
                selectedLabel: "Selezionato",
                selectLabel: "Seleziona"
              }, {
                noResult: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Nessun elemento trovato.")
                ])),
                singleLabel: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                option: _withCtx(({option}) => [
                  _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                ]),
                _: 1
              }, 8, ["onSearchChange", "loading", "options", "modelValue"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            field_name: "Descrizione",
            required: !_ctx.descrizione,
            modelValue: _ctx.descrizione,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.descrizione) = $event)),
            type: "text",
            errors: _ctx.getErrors('descrizione')
          }, null, 8, ["required", "modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.righe_iva_model, (c, i) => {
            return (_openBlock(), _createBlock(_component_RigaIvaPianoFatturazione, {
              key: i,
              iva: c.iva,
              valore: c.valore,
              "onUpdate:valore": ($event: any) => ((c.valore) = $event),
              totaliIva: _ctx.contatoriIva?.[c.iva.id],
              errors: _ctx.errors,
              chiveForm: `righe.${i}.`
            }, null, 8, ["iva", "valore", "onUpdate:valore", "totaliIva", "errors", "chiveForm"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            field_name: "Data emissione fattura",
            required: !_ctx.data_emissione_fattura,
            modelValue: _ctx.data_emissione_fattura,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data_emissione_fattura) = $event)),
            type: "date",
            errors: _ctx.getErrors('data_emissione_fattura')
          }, null, 8, ["required", "modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Field, {
            field_name: "Termini di pagamento",
            required: !_ctx.terminiDiPagamentoAutocomplete.selection,
            errors: _ctx.getErrors('termine_pagamento_id')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.terminiDiPagamentoAutocomplete.selection,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.terminiDiPagamentoAutocomplete.selection) = $event)),
                options: _ctx.terminiDiPagamentoAutocomplete.options,
                onSearchChange: _ctx.terminiDiPagamentoAutocomplete.search,
                loading: _ctx.terminiDiPagamentoAutocomplete.isLoading,
                placeholder: "Scegli termine di pagamento",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "descrizione",
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": true
              }, null, 8, ["modelValue", "options", "onSearchChange", "loading"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Field, {
            field_name: "PO",
            required: false,
            modelValue: _ctx.po,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.po) = $event)),
            errors: _ctx.getErrors('po')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Field, {
            field_name: "Bef",
            required: false,
            modelValue: _ctx.bef,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bef) = $event)),
            errors: _ctx.getErrors('bef')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Field, {
            field_name: "Note",
            required: false,
            modelValue: _ctx.note,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.note) = $event)),
            errors: _ctx.getErrors('note')
          }, null, 8, ["modelValue", "errors"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:visible', false))),
          class: "col-start-3 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        }),
        _createVNode(_component_NextButton, {
          variant: "primary",
          onClick: _ctx.save,
          class: "ml-4 py-2 px-4"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row_model?.id ? 'Modifica' : 'Aggiungi'), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}